/**
 * 
 * routes.js
 * 
 * 
 * Javascript file for handling routing on frontend application
 */
import notify from "./services/util/notify";
import token from "./services/util/roleHandler";

import { createRouter, createWebHistory } from 'vue-router';
import ClientLogin from "@/views/ClientLogin";
import StaffLogin from "@/views/StaffLogin"
import SignUp from "@/views/SignUp"
import ResetPassword from "@/views/ResetPassword"
import ClientDemographic from "@/views/ClientDemographic";

import Asa from "@/views/Asa";
import Sroi from "@/views/Sroi";

import ClientMap from "@/views/ClientMap";

import ClientFormData from "@/views/ClientFormData"
import DynamicForm from "@/views/DynamicForm";
import FormBuilder from "@/views/FormBuilder";
import TriageReferral from "@/views/TriageReferral";
import ExternalDynamicForm from "@/views/ExternalDynamicForm";
import TkClients from "@/views/TkClients";
import TkEngagements from "@/views/TkEngagements";
import TkServiceDashboard from "@/views/TkServiceDashboard";
import TkCreateEngagement from "@/views/TkCreateEngagement";
import TkEngagementDetail from "@/views/TkEngagementDetail";
import TkEnquiries from "@/views/TkEnquiries";
import TkGroups from "@/views/TkGroups";
import TkGroupDetail from "@/views/TkGroupDetail";

import TeItiKahurangiForm from "@/views/TeItiKahurangiForm";
import FormCompletedPage from "@/views/FormCompletedPage";
import PublicKoTatou from "@/views/PublicKoTatou";
import PublicKoTatouCompleted from "@/views/PublicKoTatouCompleted";

import NotFound from "@/views/404";
import Metrics from "@/views/Metrics";
import AdminDashboard from "@/views/AdminDashboard";


import Resources from "@/views/Resources"
import Reports from "@/views/Report"


const allRoutes = [
    { name: "asa", path: '/data/asa', component: Asa, meta: {requiresAuth: true, adminAccessible: true, staffAccessible: true}},
    { name: "sroi", path: '/data/sroi', component: Sroi, meta: {requiresAuth: true, adminAccessible: true, staffAccessible: true}},

    { name: "clientLogin", path: '/login/client', component: ClientLogin, default: true, meta: {hideNavbar: true}},
    { name: "staffLogin", path: '/login', component: StaffLogin, default: true, meta: {hideNavbar: true}},
    { name: "signup", path: '/signup', component: SignUp, default: true},
    { name: "resetPassword", path: '/resetPassword', component: ResetPassword, default: true, meta: {hideNavbar: true}},

    // Resources Path 
    { name: "resources", path: '/resources', component: Resources,  meta: {requiresAuth: true, adminAccessible: true, staffAccessible: true}},
    { name: "report", path: '/report', component: Reports,  meta: {requiresAuth: true, adminAccessible: true, staffAccessible: true}},

    // Staff end points 
    { name: "clientDemographic", path: '/', component: ClientDemographic, meta: {requiresAuth: true, staffAccessible: true, adminAccessible: true}},
    { name: "clientFormData", path: '/data/client-form-data', component: ClientFormData, meta: {requiresAuth: true, staffAccessible: true, adminAccessible: true, clientAccessible: true}},
    { name: "clientMap", path: '/map/client-map/all-client', component: ClientMap, meta: {requiresAuth: true, staffAccessible: true, adminAccessible: true}},


    { name: "teItiKahurangiForm", path: '/client/te-iti-kahurangi-form', component: TeItiKahurangiForm, 
                meta: { requiresAuth: true, clientAccessible: true, staffAccessible: true, adminAccessible: true}},
    
    { name: "dynamicForm", path: '/client/dynamic-form', component: DynamicForm, 
                meta: { requiresAuth: true, clientAccessible: true, staffAccessible: true, adminAccessible: true}},

    { name: "externalDynamicForm", path: '/forms/external/:token', component: ExternalDynamicForm,
                meta: { public: true, hideNavbar: true }},
    
    { name: "formBuilder", path: '/admin/form-builder', component: FormBuilder, 
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: false, adminAccessible: false }},

    { name: "triageReferral", path: '/admin/triage-referral', component: TriageReferral,
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: false, adminAccessible: true }},

    {
        path: '/tk-clients',
        component: TkEngagements,
        meta: { requiresAuth: true, clientAccessible: false, staffAccessible: true, adminAccessible: true },
        children: [
            { name: "tkClients", path: '', component: TkClients },
            { name: "tkServiceDashboard", path: 'services', component: TkServiceDashboard },
            { name: "tkEnquiries", path: 'enquiries', component: TkEnquiries },
            { name: "tkGroups", path: 'groups', component: TkGroups },
        ],
    },
    { name: "tkCreateEngagement", path: '/tk-clients/engagements/new', component: TkCreateEngagement,
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: true, adminAccessible: true }},
    { name: "tkEngagementDetail", path: '/tk-clients/people/:personId/engagements/:engagementId', component: TkEngagementDetail,
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: true, adminAccessible: true }},
    { name: "tkGroupDetail", path: '/tk-clients/groups/:groupId', component: TkGroupDetail,
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: true, adminAccessible: true }},
    
    
    { name: "formCompletedPage", path: '/client/form-completed-page', component: FormCompletedPage, 
                meta: { requiresAuth: true, clientAccessible: true, staffAccessible: true, adminAccessible: true}},

    { name: "publicKoTatou", path: '/ko-tatou', component: PublicKoTatou,
                meta: { public: true, hideNavbar: true }},
    { name: "publicKoTatouCompleted", path: '/ko-tatou/thank-you', component: PublicKoTatouCompleted,
                meta: { public: true, hideNavbar: true }},


    { name: "metrics", path: '/metrics', component: Metrics, meta: { requiresAuth: true, adminAccessible: true, staffAccessible: false }},

    // Staff administration is consolidated in one dashboard. Team leaders only
    // see permissions; admins and developers also see assignments and status.
    { name: "adminDashboard", path: '/admin/staff', component: AdminDashboard,
                meta: { requiresAuth: true, clientAccessible: false, staffAccessible: false, teamLeaderAccessible: true, adminAccessible: true }},
    { path: '/admin/staff-permissions', redirect: { name: "adminDashboard" }},
    { path: '/admin/staff-assignments', redirect: { name: "adminDashboard", query: { tab: "assignments" } }},

    // You can't redirect to `*` path, so this notFound page needs to here
    { name: "notFound", path: '/404', component: NotFound,  meta: {hideNavbar: true}},
    // Ensure this is the last route, essentially if route doesn't exist, redirect to 404 page
    { path: '/:pathMatch(.*)*', component: NotFound,  meta: {hideNavbar: true}},
    
    // Ensure this is the last route, essentially if route doesn't exist, redirect to 404 page    
];

/**
 * Check if we are allowed to access the specific route.
 * 
 * @param metaTags Route tags
 * 
 * @return {boolean} Whether or not we can access the specific route
 */
export const isAllowedToRoute = function (metaTags) {
    let canRoute = true;
    const role = token.getRole();

    if (role) {
        if (role === 'client') {
            if (!metaTags.clientAccessible) {
                notify.error("Sorry, you currently do not have permissions to access this page.", "top")
                canRoute = false
            }
        } else if (role === 'basic') {
            if (!metaTags.staffAccessible) {
                notify.error("Sorry, you currently do not have permissions to access this page.", "top")
                canRoute = false
            }
        } else if (role === 'team_leader') {
            // Team leaders are staff, but some pages (e.g. delegated permission
            // management) are open to team leaders without being open to basic staff.
            if (!metaTags.staffAccessible && !metaTags.teamLeaderAccessible) {
                notify.error("Sorry, you currently do not have permissions to access this page.", "top")
                canRoute = false
            }
        } else if (role === 'admin') {
            if (!metaTags.adminAccessible) {
                notify.error("Sorry, you currently do not have permissions to access this page.", "top")
                canRoute = false
            }
        }
    }

    return canRoute
}


//VueRouter object to handle routing
const router = createRouter({
    history: createWebHistory(),
    routes: allRoutes
});

router.beforeEach((to, from ,next) => {
    if (to.meta.public || to.name === "clientLogin" || to.name === "staffLogin" || to.name === "register") {
        next();
    } else {

        // Check if the route is allowed to be accessed
        if (!isAllowedToRoute(to.meta)) {
            const role = token.getRole()
            if (role === 'client') {
                next({ name: "clientDemographics", params: { clientId: sessionStorage.getItem("clientId")}})
            } else {
                next({ name: "clientDemographics", params: { staffId: sessionStorage.getItem("staffId")}})
            }
            
        } else {
            if (to.meta.requiresAuth) {
                if (!sessionStorage.getItem('authToken')) next('/login')
                else next()
            }   else next()
        }
    }
})

export default router;
